import React, { useEffect, useState } from 'react';
import { API_BASE } from '../../../config/api';

const fallbackTestimonials = [
    {
        id: 'fallback-1',
        customerName: 'Program Director',
        customerTitle: 'M&E Lead',
        organization: 'Regional Development Partner',
        quote: 'Stats Elite helped us turn scattered program data into clear, decision-ready insights. Their work improved our reporting rhythm and gave our team confidence in the numbers.',
        image: './images/testimonials/img-01.png'
    },
    {
        id: 'fallback-2',
        customerName: 'Operations Manager',
        customerTitle: 'Data Systems Lead',
        organization: 'Public Sector Project',
        quote: 'The team understood our context quickly and delivered practical dashboards, clean documentation, and analysis our stakeholders could act on.',
        image: './images/testimonials/img-02.png'
    },
    {
        id: 'fallback-3',
        customerName: 'Evidence Advisor',
        customerTitle: 'Research Lead',
        organization: 'Learning Initiative',
        quote: 'Stats Elite brought structure, patience, and rigor to our evaluation work. The final outputs were easy to defend and easy to use.',
        image: './images/testimonials/img-01.png'
    }
];

const normalizeTestimonials = (items) => {
    if (!Array.isArray(items) || items.length === 0) return fallbackTestimonials;

    if (items.length >= 3) return items.slice(0, 3);

    const usedIds = new Set(items.map((item) => item.id));
    const fillers = fallbackTestimonials.filter((item) => !usedIds.has(item.id));
    return [...items, ...fillers].slice(0, 3);
};

const renderStars = (rating = 5) => {
    const value = Math.max(1, Math.min(5, Number(rating) || 5));
    return Array.from({ length: 5 }, (_, index) => (
        <i key={index} className={`fa fa-star${index < value ? '' : '-o'}`}></i>
    ));
};

const getImageUrl = (image) => {
    if (!image) return '';
    if (image.startsWith('http') || image.startsWith('data:') || image.startsWith('./')) return image;
    if (image.startsWith('uploads/')) return `${API_BASE.replace(/\/api\/?$/, '')}/${image}`;
    return `${process.env.PUBLIC_URL}/${image.replace(/^\//, '')}`;
};

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState(fallbackTestimonials);

    useEffect(() => {
        let mounted = true;

        fetch(`${API_BASE}/testimonials?limit=3`)
            .then((response) => response.ok ? response.json() : [])
            .then((data) => {
                if (mounted && Array.isArray(data) && data.length > 0) {
                    setTestimonials(normalizeTestimonials(data));
                }
            })
            .catch(() => {
                if (mounted) {
                    setTestimonials(fallbackTestimonials);
                }
            });

        return () => {
            mounted = false;
        };
    }, []);

    return (
        <section className="flat-row flat-testimonials modern-testimonials-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="modern-intro-panel modern-testimonials-intro">
                            <div className="title-section center modern-section-title modern-page-title">
                                <span className="modern-title-kicker">Testimonials</span>
                                <h2>What Clients <span>Say</span></h2>
                            </div>
                            <p>Feedback from teams that trust Stats Elite to turn data, systems, and evidence into stronger decisions.</p>
                        </div>
                    </div>
                </div>
                <div className="row modern-testimonial-grid modern-testimonial-showcase">
                    {testimonials.map((item) => (
                        <div className="col-md-4 col-sm-6 col-xs-12" key={item.id}>
                            <article className="testimonials-post modern-testimonial-card">
                                <div className="featured-post modern-testimonial-avatar">
                                    {item.image ? (
                                        <img
                                            src={getImageUrl(item.image)}
                                            alt={item.customerName}
                                        />
                                    ) : (
                                        <span>
                                            {(item.customerName || '?').charAt(0)}
                                        </span>
                                    )}
                                </div>
                                <div className="modern-testimonial-card-body">
                                    <div className="modern-testimonial-stars">
                                        {renderStars(item.rating)}
                                    </div>
                                    <div className="author-name modern-testimonial-name">
                                        {item.customerName}
                                    </div>
                                    <div className="author-infomation modern-testimonial-role">
                                        {[item.customerTitle, item.organization].filter(Boolean).join(', ')}
                                    </div>
                                    <div className="entry-post modern-testimonial-copy">
                                        “{item.quote}”
                                    </div>
                                </div>
                            </article>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
